import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { UserService } from 'core/http/auth/user.service';
import { BannedAccountInterceptor } from 'core/interceptors/token/banned-account.interceptor';
import { RefreshTokenInterceptor } from 'core/interceptors/token/refresh-token.interceptor';
import { MonthsDebtsResolver, ProjectByRoute } from 'project/project-route-resolvers';

@NgModule({
  providers: [
    UserService,
    ProjectByRoute,
    MonthsDebtsResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BannedAccountInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
  ],
})
export class AuthServicesModule {
}
